export default __webpack_public_path__ + "static/media/demo3.7220b30c.png";